<ul class="a-option-bar tw-p-0">
  <ng-content></ng-content>
</ul>
